// src/store/modules/auth.js
import { login_sms, login,loginWithCaptcha,wechatLogin  } from '@/api/auth/login'
import { LOCAL_API_URL, http } from "@/api/base";

// 初始化时打印恢复状态（调试用）
const debug = process.env.NODE_ENV !== 'production'
const initialState = {
  token: localStorage.getItem('auth_token') || null,
  refreshToken: localStorage.getItem('auth_refresh_token') || null,
  loginType: localStorage.getItem('auth_login_type') || null,
  userInfo: JSON.parse(localStorage.getItem('auth_user')) || null,
  tenantInfo: JSON.parse(localStorage.getItem('auth_tenant')) || null,
  employeeInfo: JSON.parse(localStorage.getItem('auth_employee')) || null
}

if (debug) {
  console.log('[Auth Store] 初始状态从本地存储恢复:', {
    token: !!initialState.token,
    userInfo: !!initialState.userInfo,
    tenantInfo: !!initialState.tenantInfo,
    employeeInfo: !!initialState.employeeInfo
  })
}

export default {
  namespaced: true,
  state: () => ({ ...initialState }),

  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('auth_token', token)
      if (debug) console.log('[Auth Mutation] 设置token:', token ? '存在' : '空')
    },
    SET_REFRESH_TOKEN(state, refreshToken) {
      state.refreshToken = refreshToken
      localStorage.setItem('auth_refresh_token', refreshToken)
      if (debug) console.log('[Auth Mutation] 设置refreshToken:', refreshToken ? '存在' : '空')
    },
    SET_LOGIN_TYPE(state, loginType) {
      state.loginType = loginType
      localStorage.setItem('auth_login_type', loginType)
      if (debug) console.log('[Auth Mutation] 设置loginType:', loginType ? '存在' : '空')
    },
    SET_USER_INFO(state, payload) {
      console.log('=======SET_USER_INFO=====', payload)
      state.userInfo = {
        username: payload.username,
        registerTime: payload.registerTime,
        roles: payload.roles
      }
      state.tenantInfo = payload.tenantUserInfo
      state.employeeInfo = payload.employeeUserInfo

      // 独立存储各字段，避免数据覆盖
      localStorage.setItem('auth_user', JSON.stringify(state.userInfo))
      localStorage.setItem('auth_tenant', JSON.stringify(state.tenantInfo))
      localStorage.setItem('auth_employee', JSON.stringify(state.employeeInfo))

      if (debug) {
        console.log('[Auth Mutation] 设置用户信息:', {
          username: payload.username,
          tenant: !!payload.tenantUserInfo,
          employee: !!payload.employeeUserInfo
        })
      }
    },

    CLEAR_AUTH(state) {
      state.token = null
      state.refreshToken = null
      state.userInfo = null
      state.tenantInfo = null
      state.employeeInfo = null

      localStorage.removeItem('auth_token')
      localStorage.removeItem('auth_refresh_token')
      localStorage.removeItem('auth_user')
      localStorage.removeItem('auth_tenant')
      localStorage.removeItem('auth_employee')

      if (debug) console.log('[Auth Mutation] 清除所有认证状态')
    },

    // 单独更新企业信息
    UPDATE_TENANT_INFO(state, payload) {
      state.tenantInfo = payload
      localStorage.setItem('auth_tenant', JSON.stringify(payload))
      if (debug) console.log('[Auth Mutation] 更新企业信息:', payload)
    },
    // 更新租户状态（专门用于认证申请提交后的状态更新）
    UPDATE_TENANT_STATUS(state, payload) {
      if (!state.tenantInfo) {
        // 如果还没有tenantInfo，创建一个基础对象
        state.tenantInfo = {
          status: payload.status,
          id: null, // 还没有真正的ID
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          // 可以添加认证时提交的一些基本信息
          ...(payload.additionalData || {}) // 可选的其他数据
        };
      } else {
        // 如果已有tenantInfo，只更新状态和相关字段
        state.tenantInfo.status = payload.status;
        state.tenantInfo.updatedAt = new Date().toISOString();
        
        // 如果提供了额外数据，也更新
        if (payload.additionalData) {
          Object.assign(state.tenantInfo, payload.additionalData);
        }
      }
      
      // 更新本地存储，确保刷新页面后状态仍然存在
      localStorage.setItem('auth_tenant', JSON.stringify(state.tenantInfo));
      
      if (debug) console.log('[Auth Mutation] 更新租户状态为:', payload.status);
    }
  },

  actions: {
    async loginWithCaptcha({ commit }, { credentials, captchaId, captchaAnswer }) {
      try {
        const result = await loginWithCaptcha(credentials, captchaId, captchaAnswer);
        console.log('=======带验证码登录=====', result);
        
        if (result.data.code === 200) {

          commit('SET_TOKEN', result.data.data.accessToken);
          //commit('SET_REFRESH_TOKEN', result.data.data.refreshToken);
          commit('SET_LOGIN_TYPE', "password");
          commit('SET_USER_INFO', {
            username: result.data.data.username,
            registerTime: result.data.data.registerTime,
            roles: result.data.roles,
            tenantUserInfo: result.data.data.tenantUserInfo,
            employeeUserInfo: result.data.data.employeeUserInfo
          });        
        
          return { 
            success: result.data.code === 200,
            message: result.message,
            tenantUserInfo: result.data.data.tenantUserInfo,
            employeeUserInfo: result.data.data.employeeUserInfo
          };
        }
        else{
   return { 
            success: false,
            message: result.data.message,
            //tenantUserInfo: result.data.data.tenantUserInfo,
            //employeeUserInfo: result.data.data.employeeUserInfo
          };          
        }
      } catch (error) {
        commit('CLEAR_AUTH');
        throw error;
      }
    },    
    async login({ commit }, { credentials }) {
      try {
          const result = await login(credentials)
          console.log('=======login=====', result)
          if (result.code === 200) {
              commit('SET_TOKEN', result.data.accessToken)
              commit('SET_REFRESH_TOKEN', result.data.refreshToken) // 保存 refreshToken
              commit('SET_LOGIN_TYPE', "password")
              commit('SET_USER_INFO', {
                  username: result.data.username,
                  roles: result.data.roles,
                  tenantUserInfo: result.data.tenantUserInfo,
                  employeeUserInfo: result.data.employeeUserInfo
              })
          }
          return { success: true,
            data: result.data.message,
            tenantUserInfo:result.data.tenantUserInfo,
            employeeUserInfo:result.data.employeeUserInfo
           }
      } catch (error) {
          commit('CLEAR_AUTH')
          throw error
      }
    },
    async sms_login({ commit }, { credentials }) {
      console.log('sms_login action 开始:', credentials);

      try {
        const result = await login_sms(credentials);
        console.log('login_sms API响应:', result);
    //alert('login_sms result.code: ' + result.code);  // 🔴 弹窗显示
    //alert('login_sms result.data: ' + JSON.stringify(result.data));
        if (result.code === 200) {
          console.log('登录成功，准备保存token:', {
            accessToken: !!result.data.accessToken,
            refreshToken: !!result.data.refreshToken
          });


          commit('SET_TOKEN', result.data.accessToken);
          commit('SET_REFRESH_TOKEN', result.data.refreshToken);
          commit('SET_LOGIN_TYPE', "sms");
          commit('SET_USER_INFO', {
            username: result.data.username,
            registerTime: result.data.registerTime,
            roles: result.data.roles,
            tenantUserInfo: result.data.tenantUserInfo,
            employeeUserInfo: result.data.employeeUserInfo
          });
// 确保 localStorage 保存
localStorage.setItem('auth_user', JSON.stringify({
  username: result.data.username,
  registerTime: result.data.registerTime,
  roles: result.data.roles
}));
          if (debug) {
            console.log('[Auth Action] 登录成功', {
              tenant: !!result.data.tenantUserInfo,
              token: !!result.data.accessToken,
              refreshToken: !!result.data.refreshToken
            });
          }
        } else {
          console.log('登录失败，状态码:', result.code);
          return result;
        }

        return { success: result.code === 200,
          message: result.message,
          tenantUserInfo: result.data.tenantUserInfo,
          employeeUserInfo: result.data.employeeUserInfo
        };

      } catch (error) {
        console.error('[Auth Action] 登录失败:', error.message);
        commit('CLEAR_AUTH');
        throw error;
      }
    },
    async wechatLogin({ commit }, { tempCode, phone, smsCode }) {
      try {
        const result = await wechatLogin({
          tempCode,
          phone,
          smsCode
        });
        
        console.log('=======微信登录=====', result);
        
        if (result.code === 200) {
          commit('SET_TOKEN', result.data.accessToken);
          commit('SET_REFRESH_TOKEN', result.data.refreshToken);
          commit('SET_LOGIN_TYPE', "wechat");
          commit('SET_USER_INFO', {
            username: result.data.username,
            roles: result.data.roles,
            tenantUserInfo: result.data.tenantUserInfo,
            employeeUserInfo: result.data.employeeUserInfo
          });

          console.log('[Auth] userInfo 已保存:', result.data.username);
        }
        
        return { 
          success: result.code === 200,
          message: result.message,
          tenantUserInfo: result.data.tenantUserInfo,
          employeeUserInfo: result.data.employeeUserInfo
        };
      } catch (error) {
        commit('CLEAR_AUTH');
        throw error;
      }
    },    
    async tryRefreshToken({ commit, state, dispatch }) {
      if (!state.refreshToken) {
        if (debug) console.log('[Auth Action] 无refreshToken，无法刷新')
        return false
      }

      try {
        if (debug) console.log('[Auth Action] 尝试刷新token...')
        await dispatch('refreshToken')
        if (debug) console.log('[Auth Action] token刷新成功')
        return true
      } catch (error) {
        console.error('[Auth Action] 尝试刷新token失败:', error)
        commit('CLEAR_AUTH')
        return false
      }
    },
    async refreshToken({ commit, state }) {
      if (!state.refreshToken) {
        throw new Error('没有可用的刷新令牌')
      }

      try {
        // 注意：这里使用 LOCAL_API_URL 而不是 SSO_AUTH_URL
        // 因为刷新token应该调用本地服务的接口，由本地服务转发到SSO
        const response = await http.post(`${LOCAL_API_URL}/auth/refresh`, {}, {
          headers: {
            Authorization: `Bearer ${state.refreshToken}`
          }
        })

        if (response.data.code === 200) {
          commit('SET_TOKEN', response.data.data.accessToken)
          commit('SET_REFRESH_TOKEN', response.data.data.refreshToken)
          if (debug) console.log('[Auth Action] token刷新成功')
          return response.data.data.accessToken
        } else {
          throw new Error(response.data.message)
        }
      } catch (error) {
        commit('CLEAR_AUTH')
        throw error
      }
    },

      // 增强版logout处理
      logout({ commit, state }) {
        return new Promise((resolve, reject) => {
          // 如果有token才调用logout接口
          const shouldCallAPI = !!state.token

          const cleanup = () => {
            commit('CLEAR_AUTH')
            window.location.href = '/login' // 强制刷新确保状态清除
          }

          if (shouldCallAPI) {
            http.post(`${LOCAL_API_URL}/auth/logout`)
              .then(() => {
                if (debug) console.log('[Auth Action] 退出登录成功')
                cleanup()
                resolve()
              })
              .catch(error => {
                console.error('[Auth Action] 退出登录失败:', error)
                cleanup() // 即使API失败也清除本地状态
                reject(error)
              })
          } else {
            if (debug) console.log('[Auth Action] 无有效token，直接清除本地状态')
            cleanup()
            resolve()
          }
        })
      },

    // 初始化检查（用于应用启动时）
    initialize({ commit/*, state */}) {
      return new Promise(resolve => {
        const token = localStorage.getItem('auth_token')
        const userInfo = JSON.parse(localStorage.getItem('auth_user') || 'null')
        const tenantInfo = JSON.parse(localStorage.getItem('auth_tenant') || 'null')
        
        // 🔴 添加日志
        console.log('[Auth Initialize] token:', !!token)
        console.log('[Auth Initialize] userInfo:', userInfo)
        console.log('[Auth Initialize] tenantInfo:', tenantInfo)
        
        if (token && userInfo) {
          commit('SET_TOKEN', token)
          // 恢复 userInfo 和 tenantInfo
          commit('SET_USER_INFO', {
            username: userInfo.username,
            registerTime: userInfo.registerTime,
            roles: userInfo.roles,
            tenantUserInfo: tenantInfo,
            employeeUserInfo: JSON.parse(localStorage.getItem('auth_employee') || 'null')
          })
          resolve(true)
        } else {
          resolve(false)
        }
      })
    },

  },




  getters: {
    isAuthenticated: state => !!state.token,
    currentTenant: state => state.tenantInfo,
    currentUser: state => state.userInfo
  }
}